$(function () {

    const $stateValue = $('[name="company_image_state"]');
    const $pathValue = $('[name="company_image_path"]');
    const $typeValue = $('[name="company_image_type"]');
    const $thumbnailValue = $('[name="company_image_thumbnail"]');
    const $thumbnailTag = $('.js-company-images-thumbnail-preview');

    const $error = $('.js-company-images-error');

    $('.js-company-images-upload').change(function (e) {

        const $file = $(e.target);

        const action = $(e.target).data('action');

        // 表示中のサムネイルを非表示
        $thumbnailTag.find('img').hide();

        // エラー状態初期化
        $file.removeClass('is-invalid');
        $error.text('');

        // Loading表示
        const $loading = $('<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>');
        $thumbnailTag.append($loading);

        let formData = new FormData();
        let file = $(this)[0].files[0];
        formData.append('image', file, file.name);
        $.ajax({
            url: action,
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            type: 'POST',
            contentType: false,
            processData: false,
            cache: false,
            data: formData,
            success: function (data) {

                $stateValue.val('create');
                $pathValue.val(data.response.path);
                $typeValue.val(data.response.type);
                $thumbnailValue.val(data.response.thumbnail);

                // 表示中のサムネイルを削除
                $thumbnailTag.find('img').remove();

                // 新しいimgタグを作成表示
                $thumbnailTag.append(`<img src="${data.response.link}">`);
            },
            error: function (data) {
                $file.addClass('is-invalid');
                if (data.responseJSON) {
                    $error.text(Object.values(data.responseJSON.errors).join('\n'));
                } else {
                    // webサーバーでpost maxサイズを超えてエラーになる場合status textが表示される
                    $error.text(data.statusText);
                }

                // エラーの場合は非表示にした画像を表示する
                $thumbnailTag.find('img').show();
            },
            complete: function () {
                // ローディング削除
                $loading.remove();
            }
        });
    });
})
